(function() {
  if (window.__abrsmCartDrawerShippingMessageInit) {
    return;
  }
  window.__abrsmCartDrawerShippingMessageInit = true;

  var selector = '[data-drawer-free-shipping]';

  function getRoot() {
    return document.querySelector(selector);
  }

  function syncDiscountSummary() {
    var summary = document.querySelector('#CartDrawer [data-discounts]');
    if (!summary) {
      return;
    }

    var discountCard = summary.querySelector('.cart__discounts');
    var hasVisibleDiscount = !!discountCard && !discountCard.classList.contains('hide') && discountCard.textContent.replace(/\s+/g, ' ').trim() !== 'Discounts';

    summary.classList.toggle('is-empty', !hasVisibleDiscount);
  }

  function observeDiscountSummary() {
    var summary = document.querySelector('#CartDrawer [data-discounts]');
    if (!summary || summary._abrsmDiscountObserver) {
      return;
    }

    var observer = new MutationObserver(function() {
      syncDiscountSummary();
    });

    observer.observe(summary, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    summary._abrsmDiscountObserver = observer;
  }

  function formatMoney(amount) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
    }

    return 'GBP ' + ((amount || 0) / 100).toFixed(2);
  }

  function applyState(cart) {
    var root = getRoot();
    var clearButton = document.querySelector('[data-cart-drawer-clear]');
    var viewCartButton = document.querySelector('[data-cart-drawer-view-cart]');
    var countPill = document.querySelector('[data-cart-drawer-count]');
    if (!root) {
      return;
    }

    var message = root.querySelector('[data-drawer-free-shipping-message]');
    var fill = root.querySelector('[data-drawer-free-shipping-fill]');
    var threshold = Number(root.getAttribute('data-threshold')) || 5000;
    var totalPrice = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    var itemCount = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    var progress = threshold > 0 ? Math.min(100, Math.max(0, (totalPrice / threshold) * 100)) : 0;

    if (!message || !fill) {
      return;
    }

    if (itemCount <= 0) {
      root.classList.add('is-hidden');
      message.textContent = '';
      fill.style.width = '0%';
      if (clearButton) {
        clearButton.classList.add('is-hidden');
        clearButton.disabled = false;
        clearButton.textContent = 'Empty basket';
      }
      if (viewCartButton) {
        viewCartButton.classList.add('is-hidden');
      }
      if (countPill) {
        countPill.classList.add('is-hidden');
        countPill.textContent = '0 items';
      }
      return;
    }

    root.classList.remove('is-hidden');
    root.classList.toggle('is-complete', totalPrice >= threshold);
    fill.style.width = progress + '%';
    if (clearButton) {
      clearButton.classList.remove('is-hidden');
      clearButton.disabled = false;
      clearButton.textContent = 'Empty basket';
    }
    if (viewCartButton) {
      viewCartButton.classList.remove('is-hidden');
    }
    if (countPill) {
      countPill.classList.remove('is-hidden');
      countPill.textContent = itemCount + (itemCount === 1 ? ' item' : ' items');
    }

    if (totalPrice >= threshold) {
      message.textContent = 'Free delivery unlocked';
      return;
    }

    message.textContent = formatMoney(threshold - totalPrice) + ' to free delivery';
  }

  function refresh() {
    if (!window.fetch || !window.theme || !theme.routes || !theme.routes.cart) {
      return;
    }

    observeDiscountSummary();

    fetch(theme.routes.cart + '?t=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function(response) {
        if (!response || !response.ok) {
          throw new Error('Cart request failed');
        }

        return response.json();
      })
      .then(function(cart) {
        applyState(cart);
        syncDiscountSummary();
      })
      .catch(function() {});
  }

  document.addEventListener('click', function(event) {
    var removeLink = event.target && event.target.closest ? event.target.closest('#CartDrawer .cart__remove a') : null;
    if (!removeLink) {
      return;
    }

    if (!window.theme || !theme.cart || typeof theme.cart.changeItem !== 'function') {
      return;
    }

    var removeUrl;
    try {
      removeUrl = new URL(removeLink.href, window.location.origin);
    } catch (error) {
      return;
    }

    var itemKey = removeUrl.searchParams.get('id');
    if (!itemKey || removeLink.getAttribute('aria-disabled') === 'true') {
      return;
    }

    event.preventDefault();
    var originalText = removeLink.textContent;
    removeLink.setAttribute('aria-disabled', 'true');
    removeLink.textContent = 'Removing...';

    theme.cart.changeItem(itemKey, 0)
      .then(function(cartResponse) {
        var cart = typeof cartResponse === 'string' ? JSON.parse(cartResponse) : cartResponse;
        applyState(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: cart
          }
        }));
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function() {
        removeLink.removeAttribute('aria-disabled');
        removeLink.textContent = originalText;
        window.location.assign(removeUrl.href);
      });
  });

  document.addEventListener('click', function(event) {
    var clearButton = event.target && event.target.closest ? event.target.closest('[data-cart-drawer-clear]') : null;
    if (!clearButton) {
      return;
    }

    if (!window.fetch || !window.theme || !theme.routes || !theme.routes.cartPage) {
      return;
    }

    if (!window.confirm('Are you sure you want to empty your basket?')) {
      return;
    }

    clearButton.disabled = true;
    clearButton.textContent = 'Emptying...';

    fetch(theme.routes.cartPage + '/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function(response) {
        if (!response || !response.ok) {
          throw new Error('Clear cart failed');
        }

        return response.json();
      })
      .then(function(cart) {
        applyState(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: cart
          }
        }));
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function() {
        clearButton.disabled = false;
        clearButton.textContent = 'Empty basket';
      });
  });

  document.addEventListener('DOMContentLoaded', function() {
    observeDiscountSummary();
    refresh();
    syncDiscountSummary();
  });
  document.addEventListener('cart:build', function() {
    window.setTimeout(function() {
      observeDiscountSummary();
      refresh();
      syncDiscountSummary();
    }, 0);
  });
  document.addEventListener('cart:updated', function() {
    window.setTimeout(syncDiscountSummary, 0);
    refresh();
  });
  document.addEventListener('ajaxProduct:added', function() {
    window.setTimeout(syncDiscountSummary, 0);
    refresh();
  });
  document.addEventListener('cart:open', function() {
    observeDiscountSummary();
    refresh();
    syncDiscountSummary();
  });
})();
